export default {
  errors: {
    UNKNOWN_ERROR: "An unexpected error occurred. Please try again later.",
    AUTH_BAD_AUTHENTICATION: "Invalid authentication. Please try again.",
    AUTH_ROLE_NOT_FOUND: "Registration role not found. Contact support.",
    AUTH_USER_ALREADY_REGISTERED: "This email is already registered. Try logging in instead.",
    AUTH_USER_NOT_FOUND: "User not found. Please check your email or register.",
    AUTH_BAD_INPUT_PARAMETER: "Invalid input data. Please check your information.",
    AUTH_BAD_TYPE_RENDERED: "An unexpected error occurred. Please try again.",
    AUTH_COMMON_ERROR: "An error occurred. Please try again.",
    AUTH_BAD_AUTH_CODE_TYPE: "Invalid authentication code type.",
    AUTH_RATE_LIMIT_EXCEEDED: "Too many requests. Please wait a moment and try again.",
    USER_NOT_AUTHENTICATED: "Your session has expired. Please log in again.",
    USER_NOT_GRANTED: "You do not have permission to access this information.",
    USER_KYC_SESSION_NOT_FOUND: "Identity verification not found. Please complete the KYC process.",
    USER_NOT_GRANTED_TO_VIEW_INFO: "You do not have permission to view this user information.",
    USER_BAD_INPUT_PARAMETER: "Invalid input data. Please try again.",
    USER_BAD_TYPE_RENDERED: "An unexpected error occurred. Please try again.",
    USER_COMMON_ERROR: "An error occurred loading your profile. Please try again.",
    unknown: "An unexpected error occurred. Please try again later.",
  },
  shared: {
    step: {
      credentials: "Enter your email",
      verification: "Verify your email",
    },
    email: {
      label: "Email",
      placeholder: "your@email.com",
    },
    button: "Continue",
    error: {
      sendingCode: "Error sending code",
    },
    verify: {
      title: "We have sent a code to",
      subtitle: "Enter the 6-digit code",
      codeLabel: "Verification code",
      changeEmail: "Change email",
      resendCode: "Resend code",
      resendSuccess: "Code resent. Check your inbox.",
      error: {
        incompleteCode: "Please complete the 6-digit code",
        invalidCode: "Invalid or expired code",
        title: "Error",
        message: "The code you entered is not correct, please try again.",
      },
    },
  },
  login: {
    title: "Login",
    votePrompt: "Log in to view the vote",
    registerLink: "Don’t have an account? Register",
    verify: {
      button: "Login",
      infoMessage: "You will only receive the code if you have previously registered.",
      resendSuccess: "Code resent to your email. You will only receive it if you have previously registered.",
    },
  },
  register: {
    title: "Register",
    acceptTerms: {
      prefix: "I accept and confirm that I have read the",
      link: "terms and conditions",
    },
    acceptPrivacy: {
      prefix: "I accept and confirm that I have read the",
      link: "privacy notice",
    },
    verify: {
      button: "Complete registration",
    },
  },
}
